import { FC, ReactNode, useRef } from 'react';
import classnames from 'classnames';
import { SelectPicker, Form } from 'rsuite';
import { RsSelectSize, sizeMap } from './size';
import styles from './select.module.scss';
// import { ItemDataType } from 'rsuite';

export interface SelectDataType<T = any> {
  value: T;
  label: string;
}
interface RsSelectProps {
  data: SelectDataType[];
  value: any;
  onChange: (s: any) => void;
  className?: string;
  placeholder?: string;
  searchable?: boolean;
  disabled?: boolean;
  cleanable?: boolean;
  errorMessage?: string;
  showError?: boolean;
  size?: RsSelectSize;
  disabledItemValues?: string[];
  renderMenuItem?: (label: ReactNode, item: any) => ReactNode;
  renderValue?: (label: ReactNode, item: any) => ReactNode;
  menuMaxHeight?: number;
}

export const RsSelect: FC<RsSelectProps> = ({
  data = [],
  value,
  onChange,
  className = '',
  placeholder = 'select',
  searchable = false,
  cleanable = true,
  disabled = false,
  errorMessage,
  size = RsSelectSize.LARGE,
  disabledItemValues,
  renderMenuItem,
  renderValue,
  menuMaxHeight,
}) => {
  const containerRef = useRef(null);
  return (
    <div className='rs-form-control-wrapper' ref={containerRef}>
      <SelectPicker
        data={data}
        value={value}
        onChange={onChange}
        searchable={searchable}
        className={classnames(styles.RsSelect, sizeMap[size], className)}
        placeholder={placeholder}
        disabled={disabled}
        cleanable={cleanable}
        placement='bottomStart'
        container={containerRef.current || undefined}
        disabledItemValues={disabledItemValues}
        renderMenuItem={renderMenuItem}
        renderValue={renderValue}
        menuMaxHeight={menuMaxHeight}
      />
      <Form.ErrorMessage
        show={(errorMessage as string) !== undefined}
        placement='topEnd'
      >
        {errorMessage}
      </Form.ErrorMessage>
    </div>
  );
};
